import { Button, type ButtonProps } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";

type AddPrepaymentButtonProps = ButtonProps;

export const AddPrepaymentButton = (props: AddPrepaymentButtonProps) => {
  return (
    <Button
      colorScheme="grey"
      leftIcon={<Icon name="plus" w="5" h="5" color="grey.500" />}
      onClick={props.onClick}
      variant="outline"
    >
      <Trans>Add prepayment</Trans>
    </Button>
  );
};
